module.exports = __webpack_public_path__ + "images/payment-73ea17b3.svg";